import { render, staticRenderFns } from "./addRulePf.vue?vue&type=template&id=3a65e364&scoped=true&"
import script from "./addRulePf.vue?vue&type=script&lang=js&"
export * from "./addRulePf.vue?vue&type=script&lang=js&"
import style0 from "./addRulePf.vue?vue&type=style&index=0&id=3a65e364&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65e364",
  null
  
)

export default component.exports